(function(){
  var style=document.createElement('style');
  style.textContent='#tm-b{position:fixed;top:0;left:0;right:0;z-index:9999;background:#1E3D2F;color:#F2E8D0;font:13px/1.4 "Inter",sans-serif;text-align:center;padding:8px 40px 8px 16px;box-shadow:0 2px 6px rgba(0,0,0,.25);display:flex;align-items:center;justify-content:center;gap:6px}#tm-b a{color:#79B83C;font-weight:600;text-decoration:none}#tm-b a:hover{text-decoration:underline}#tm-x{position:absolute;right:10px;top:50%;transform:translateY(-50%);background:none;border:none;color:inherit;cursor:pointer;opacity:.7;font-size:16px;padding:4px}body.tm-open{padding-top:36px!important}';
  document.head.appendChild(style);
  var b=document.createElement('div');
  b.id='tm-b';
  b.innerHTML='<span>⚠️ <strong>Solo emitimos boletas de venta electrónicas.</strong> Para ventas corporativas: <a href="mailto:hola@todomate.cl">hola@todomate.cl</a></span><button id="tm-x" title="Cerrar">✕</button>';
  function show(){
    try{if(sessionStorage.getItem('tm_closed'))return;}catch(e){}
    document.body.classList.add('tm-open');
    document.body.insertBefore(b,document.body.firstChild);
    b.querySelector('#tm-x').onclick=function(){
      b.remove();
      document.body.classList.remove('tm-open');
      try{sessionStorage.setItem('tm_closed','1');}catch(e){};
    };
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',show);}else{show();}
})();
